/* ============
 * Getters for the pixel module
 * ============
 *
 * The getters that are available on the
 * pixel module.
 */

export default {};
